<template>
    <div v-if="isAdmin" class="panel-admin-body">
        <div class="title">{{ title }}</div>
        <div class="container survey-list">
            <div class="filter-container border-bottom pt-3 pb-3">      
                <div class="row">
                    <div class="col-2">
                        <div class="w-100"><b>Date Created</b></div>
                        <div class="d-flex">
                            <div class="form-group">
                                <label for="startDateCreated" class="mr-1">Start</label>
                                <datepicker format="MMM dd yyyy" v-model="startDateCreated" :typeable="true" wrapper-class="" input-class="form-control required w-100 bg-white" name="startDateCreated"></datepicker>
                            </div>
                            <div class="form-group ml-2">
                                <label for="endDateCreated" class="mr-1">End</label>
                                <datepicker format="MMM dd yyyy" v-model="endDateCreated" :typeable="true" wrapper-class="" input-class="form-control required w-100 bg-white" name="endDateCreated"></datepicker>
                            </div>
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="w-100"><b>Last Modified</b></div>
                        <div class="d-flex">
                            <div class="form-group">
                                <label for="startDateModified" class="mr-1">Start</label>
                                <datepicker format="MMM dd yyyy" v-model="startDateModified" :typeable="true" wrapper-class="" input-class="form-control required w-100 bg-white" name="startDateModified"></datepicker>
                            </div>
                            <div class="form-group ml-2">
                                <label for="endDateCreated" class="mr-1">End</label>
                                <datepicker format="MMM dd yyyy" v-model="endDateCreated" :typeable="true" wrapper-class="" input-class="form-control required w-100 bg-white" name="endDateCreated"></datepicker>
                            </div>
                        </div>
                    </div>                    
                    <div class="col-2">
                        <div class="w-100">&nbsp;</div>
                        <div class="d-flex">
                            <div class="form-group ml-2">
                                <label for="surveyGroup" class="mr-1" >Group Name</label>
                                <select
                                    id="surveyGroup"
                                    name="surveyGroup"
                                    class="custom-select shadow"
                                    v-model="surveyGroupId"
                                    >
                                    <option value=0>Select Survey Group</option>
                                    <option v-for="(option, idxSurveyGroupOptions) in survey_group_options" 
                                            v-bind:value="option.value" v-bind:key="idxSurveyGroupOptions">
                                        {{ option.name }}
                                    </option>
                                </select>
                            </div>                    
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="d-flex justify-content-start pt-2">
                        <div class="pr-2">
                            <button type="button" class="btn btn-primary ml-2" id="FilterButton" @click="filterData()">Filter</button>
                        </div>
                        <div class="pr-2">
                            <button type="button" class="btn btn-primary ml-2" id="ResetButton" @click="reset()">Reset</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="button-container pt-1 pb-1">
                <div class="button-left">
                    <div class="pr-2">
                        <button type="button" class="btn btn-primary" id="DuplicateSurveyButton" :disabled="!copyCardButtonEnabled" @click="copySavedCard">
                        Copy Card
                        <span class="ml-auto">
                            <font-awesome-icon :icon="['fa', 'copy']" />
                        </span>
                        </button>
                    </div>
                    <div class="pr-2">
                        <a href="#" @click="displayDeleteConfirmation(deleteClientCharts,clientChartIdsToDelete,'Delete Confirmation Card','Are you sure you want delete the selected cards ?')">
                        <button type="button" class="btn btn-primary delete-card" id="DeleteSurveyButton" :disabled="!deleteCardButtonEnabled">
                            Delete Card 
                            <span class="ml-auto">
                            <font-awesome-icon :icon="['fa', 'minus-circle']" />
                            </span>
                        </button>
                        </a>
                    </div>
                </div>
            </div>
            <div>
                Reminder: Only one card can be copied at a time.
            </div>
            <div class="data-container pt-1 pb-1">
                <div class="col-12">
                    <table :id="table.id" :class="table.class" cellspacing="0" width="100%" style="width: 100%;">
                        <thead></thead>
                        <tbody></tbody>
                    </table>
                </div>
            </div>
        </div>
        <copy-saved-card ref="copySavedCard" 
            :input-saved-card="savedCard"
            :input-survey-group-options="full_list_of_survey_group_options"
            @save="reload"/>
    </div>
</template>

<script>
import $ from "jquery";
import Datepicker from "vuejs-datepicker";

import FilterMixins from "../../mixins/FilterMixins.vue";
import AdminMixins from "../../mixins/AdminMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import ClientChartService from "../../services/client.chart.service";
import AdminService from "../../services/admin.service";
import ReportService from  "../../services/report.service";
import SurveyGroupService from "../../services/survey.group.service";
import CopySavedCard from "../../modals/CopySavedCard.vue";

export default {
    name: "SavedCardList",
    mixins: [AdminMixins, DataTableMixins,FilterMixins],
    components: {Datepicker,CopySavedCard},
    data() {
        return {
            title: "Saved Card List",
            table: {
                id: "saved-card-list-table",
                class: "table display wrap row-border table-hover",
                configuration: {
                dom: '<"top"if>rtp<"bottom"l><"clear">',
                searching: true,
                paging: true,
                select: true,
                destroy: true,
                info: false,
                ordering: true,
                bSort: true,
                bSortable: true,
                keys: true,
                autoWidth: false,
                processing: true,
                responsive: false,
                order: [[1, 'asc']],
                columnDefs: [
                    {
                    targets: 0,       // index of the select-all column
                    orderable: false  // disable sorting
                    }
                ]
                },
                columns: ClientChartService.getAdminSavedCardTableColumnData()
            },
            tableSortBy: [1, "desc"],
            returnMessage: "",
            clientChartIdsToDelete: [],
            numberOfCopies: 1,
            surveyGroupId: 0,
            full_list_of_survey_group_options: [],
            survey_group_options: [],
            survey_id_list: [],
            startDateCreated: new Date(2014, 1, 1),
            endDateCreated: new Date(),
            startDateModified: new Date(2014, 1, 1),
            endDateModified: new Date(),
        }
    },    
    props: {},
    methods: {
        copySavedCard(){
            this.$modal.show('copy-saved-card');
        },
        async deleteClientCharts(result) {
            ClientChartService.deleteClientCharts(this.clientChartIdsToDelete,this.deleteClientChartsCallback,this);
        },     
        deleteClientChartsCallback(response) {
            this.$root.processServerResponse();
            let statusCode = response.data.statusCode;
            if (statusCode == 200) {
                AdminService.displaySuccessMessage({ text: response.data.message });
                this.clientChartIdsToDelete = [];
                this.getTableData();
            } else {
                AdminService.displayErrorMessage({ text: response.data.message });
            }
        },
        async getTableData() {
            this.startDateCreated.setHours(12, 0, 0, 0);
            this.endDateCreated.setHours(12, 0, 0, 0);
            this.startDateModified.setHours(12, 0, 0, 0);
            this.endDateModified.setHours(12, 0, 0, 0);
            this.originalList = [];
            this.$root.processServerRequest("Loading table data");
            await SurveyGroupService.getSurveyGroupsByClientId(this.clientObject.clientCode,this.getSurveyGroupsByClientIdCallback, this);
            await ClientChartService.getSavedCardList(this.getSavedCardTableDataCallback, this);
        },
        async getSavedCardTableDataCallback(response)  {
            this.originalList = response.data.data.savedCardList;
            this.full_list_of_survey_group_options = response.data.data.surveyGroupList;
            this.full_list_of_survey_group_options.sort(ReportService.compareValues("name", "asc"));

            await this.filterData();            
            this.table.configuration.order = this.tableSortBy;
            this.setupRowClick();
            this.$root.processServerResponse();
        },
        getSurveyGroupsByClientIdCallback(response) {
            this.survey_group_options = [];
            let statusCode = response.data.statusCode;
            if (statusCode == 200) {
                let surveyGroups = response.data.data.surveyGroupList;
                this.survey_group_options =  SurveyGroupService.getSurveyGroupOptions(surveyGroups,"Y",this.clientId);
            } else if (statusCode == 201) {
                //        AdminService.displaySuccessMessage({ text: response.data.message, duration: -1 });
            } else {
                AdminService.displayErrorMessage({ text: response.data.message });
            }
        },
        getSurveyListBySurveyGroupCallback(response) {
            this.survey_id_list = [];
            let statusCode = response.data.statusCode;
            if (statusCode == 200) {
                let surveyList = response.data.data.surveyList;
                this.survey_id_list =  surveyList.map(entry => entry.surveyId);
            } else if (statusCode == 201) {
                //        AdminService.displaySuccessMessage({ text: response.data.message, duration: -1 });
            } else {
                AdminService.displayErrorMessage({ text: response.data.message });
            }
        },
        async filterData(){
            let goAheadAndFilterData = false;
            if (this.surveyGroupId > 0){
                goAheadAndFilterData = true;
                await SurveyGroupService.getSurveyListBySurveyGroup(this.surveyGroupId,this.getSurveyListBySurveyGroupCallback, this);
                this.filteredList =  ClientChartService.getClientChartsBySurveyIds(this.originalList, this.survey_id_list, true);
            } else if (typeof this.clientObject !== "undefined" &&
                            typeof this.clientObject.clientId !== "undefined" && this.clientObject.clientId > 0){
                goAheadAndFilterData = true;
                this.filteredList =  ClientChartService.getClientChartsByClient(this.originalList, this.clientObject.clientId, true);
            }
            // further filter by created date
            this.filteredList = ClientChartService.filterSavedCardListByCreatedDate(this.filteredList, this.startDateCreated, this.endDateCreated);
            // further filter by modified date
            this.filteredList = ClientChartService.filterSavedCardListByModifiedDate(this.filteredList, this.startDateModified, this.endDateModified);

            if (goAheadAndFilterData == true){
                this.table.data = this.filteredList;
            } else {
                this.table.data = this.originalList;
            }
            this.setupTable();
            this.setupRowClick();
        },
        setupRowClick(){
            const vm = this;
            const th = $('#saved-card-list-table thead').find("th").eq(0);
            th.html('<input type="checkbox" id="select-all" class="text-center"/>');
            
            if( this.table.dataTable.click == undefined)  {

                this.table.dataTable.on("click", 'input[type="checkbox"]', function(e, dt, type, indexes) {
                    var $row = $(this).closest("tr");
                    var data = vm.table.dataTable.row($row).data();
                    if (!$.isEmptyObject(data)) {
                        if (e.target.checked) {
                            if (!vm.clientChartIdsToDelete.includes(data.clientChartId)){
                                vm.clientChartIdsToDelete.push(data.clientChartId);
                            }
                        } else {
                            var match = vm.clientChartIdsToDelete.find(x => x === data.clientChartId);
                            if (typeof match !== "undefined") {
                                vm.clientChartIdsToDelete.splice($.inArray(match, vm.clientChartIdsToDelete), 1);
                            }
                        }
                    }
                });   
                $('#select-all').on('click', function(){
                    if ($(this).is( ":checked" )) {
                        vm.selectAll();
                        // Disable ordering for all columns
                        const table = $('#saved-card-list-table').DataTable();
                        table.columns().every(function () {
                            this.orderable(false);
                        });
                    } else {
                        vm.deselectAll();
                        // Re-enable ordering if needed
                        const table = $('#saved-card-list-table').DataTable();
                        table.columns().every(function () {
                            this.orderable(false);
                        });
                    }      
                });      
        }

        },
        async reload(message){
            await this.getTableData();
            if (this.$refs['copy-saved-card'] != null) {
                this.$refs['copy-saved-card'].visible = false;
            }
            AdminService.displaySuccessMessage({ text: message });
        },
        reset(){
            this.surveyGroupId = 0;        
            this.survey_id_list = [];
            this.startDateCreated = new Date(2014, 1, 1);
            this.endDateCreated = new Date();
            this.startDateModified = new Date(2014, 1, 1);
            this.endDateModified = new Date();
            this.filterData();
            this.table.configuration.order = this.tableSortBy;
            this.setupTable();
            this.setupRowClick();
        },
        isSavedDasboardCard(clientChart){
            return clientChart.dashboardCardId != 0;
        },
        deselectAll: function(){
            this.clientChartIdsToDelete = [];
            // uncheck all rows in table
            let vm = this;
            // deselect all checkboxes in DOM at once
            $(vm.table.dataTable.rows().nodes()).find('input[name="id[]"]').prop('checked', false);
        },
        addToDownloadSets: function(data){
            if (!$.isEmptyObject(data)) {
                this.clientChartIdsToDelete.push(data.clientChartId);
            }
        },
        selectAll: function(){
            let vm = this;
            vm.table.dataTable.rows({ page: 'current' }).every(function(rowIdx){
                var $row = $( this.node() );
                let data = vm.table.dataTable.row($row).data();
                vm.addToDownloadSets(data);
                $row.find('input[name="id[]"]').prop('checked', true)
            });
        }
    },   
    computed: {
        deleteCardButtonEnabled: function(){
            return this.clientChartIdsToDelete.length > 0;
        },
        copyCardButtonEnabled: function(){
          let isCopyCardEnabled = this.table.rowSelected;
          if(isCopyCardEnabled == true){
            if (!$.isEmptyObject(this.getDataFromSelectedRow())) {            
                return this.getDataFromSelectedRow().displayType != "winners" && !this.isSavedDasboardCard(this.getDataFromSelectedRow());
            } else {
                isCopyCardEnabled == false;
            }
          }
          return isCopyCardEnabled;
        },
        savedCard: function(){
            if (!$.isEmptyObject(this.getDataFromSelectedRow())) {            
                return this.getDataFromSelectedRow();
            }
            return {};
        }
    },
    created() {
        this.getTableData();
    },    
    mounted() {}, 
    watch : {
        clientObject: function() {
            this.reset();
            this.getTableData();
            this.filterData();
        }
    }   
};
</script>